module.exports = __webpack_public_path__ + "img/P659205807.135f6bdb.jpg";